namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerEditor()
    export class SOLookupcustom extends
        Serenity.LookupEditorBase<Serenity.LookupEditorOptions, any> {

        public myId: string;

        constructor(container: JQuery, opt: Serenity.LookupEditorOptions) {
            super(container, opt);
        }

        protected getLookupKey() {
            return this.buildLookupKey(this.myId);
        }

        protected getItems(lookup: Q.Lookup<any>) {
            var customLookup = Q.getLookup(this.buildLookupKey(this.myId));

            let items: any = super.getItems(customLookup);

            // this is demo about filtering lookup items

            // only take item that has Id % 5 = 0 (5, 10, 15, 20...)
            // items = items.filter(x => Q.toId(x.Id) % 5 == 0); // here 'Id' field is hardcode for demo
            items = items.filter(x => Q.toId(x.StockFrom) == this.myId); // here 'Id' field is hardcode for demo

            // just take maximum first 5 items
            // if (items.length >= 5) {
            //     return items.slice(0, 5);
            // }
            // else {
                return items;
            // }
        }

        private buildLookupKey(id?: string): string {

            //demo switch lookup key by id

            // if (id == 100) {


                return "Inventory.LookupIcSoLookup";
            // } else {
            //     if (id == 200) {
            //         return "Default.State";
            //     }
            //     else {
            //         return "Supplier.Supplier"; // default
            //     }
            // }
        }
    }    
}